import React, { useEffect, useState } from "react";
import "./style.css";
import { Button, Col, Form, Input, Row, notification } from "antd";
import { updateAccount } from "../../../../api/settings";
import { useSelector } from "react-redux";

const Accounts = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { admin } = useSelector((state) => state.admin);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await updateAccount(values, admin?.email);
      setLoading(false);
      form.setFieldValue("password", undefined);
      if (admin?.email !== values?.email && values?.password?.trim() !== "") {
        notification.success({
          message: "Success",
          description: "Account updated successfully!",
        });
      }
    } catch (error) {
      setLoading(false);
      notification.error({
        message: "Error",
        description: "An error occurred while updating settings.",
      });
    }
  };

  useEffect(() => {
    form.setFieldValue("email", admin?.email || undefined);
  }, [admin]);

  const validatePassword = (_, value) => {
    if (value && value.length < 8) {
      return Promise.reject(
        new Error("Password must be at least 8 characters")
      );
    }
    return Promise.resolve();
  };

  return (
    <div className="account_tab_container">
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        requiredMark={false}
        autoComplete="off"
      >
        <Row gutter={[20, 0]}>
          <Col xs={24} md={7}>
            <Form.Item
              label="Email address"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Required",
                  type: "email",
                },
              ]}
            >
              <Input type="email" />
            </Form.Item>
          </Col>
          <Col xs={24}></Col>
          <Col xs={24} md={7}>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  validator: validatePassword,
                },
              ]}
            >
              <Input min={8} />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Button
              className="button"
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "200px", marginTop: "10px", height: "37px" }}
            >
              SAVE
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Accounts;
